import React from 'react';

interface Testimonial {
  quote: string;
  author: string;
  quoteIcon?: string;
  backgroundStyle?: 'default' | 'bg-2' | 'bg-3';
}

interface KidsaTestimonialProps {
  subtitle?: string;
  title?: string;
  testimonials: Testimonial[];
}

const KidsaTestimonial: React.FC<KidsaTestimonialProps> = ({
  subtitle = "testimonials",
  title = "Parents' words are the key <br> to happy kids",
  testimonials
}) => {
  return (
    <section className="testimonial-section fix section-padding" id="comunicados">
      <div className="tree-shape float-bob-y">
        <img src="/assets/kidsa/assets/img/crayons.png" alt="shape-img" />
      </div>
      <div className="right-shape">
        <img src="/assets/kidsa/assets/img/testi-r-shape.png" alt="shape-img" />
      </div>
      <div className="bee-shape float-bob-y">
        <img src="/assets/kidsa/assets/img/testi-bee-shape.png" alt="shape-img" />
      </div>
      <div className="container">
        <div className="section-title text-center">
          <span className="wow fadeInUp">{subtitle}</span>
          <h2 
            className="wow fadeInUp text-transform-none" 
            data-wow-delay=".3s"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        </div>
        <div className="swiper testimonial-slider">
          <div className="swiper-wrapper">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="swiper-slide">
                <div className={`testimonial-items ${testimonial.backgroundStyle ? `style-${testimonial.backgroundStyle.replace('bg-', '')}` : ''}`}>
                  <div className="icon">
                    <img 
                      src={testimonial.quoteIcon || "/assets/kidsa/assets/img/quote.png"} 
                      alt="img" 
                    />
                  </div>
                  <div className={`testimonial-bg ${testimonial.backgroundStyle || ''}`}></div>
                  <div className="testimonial-content">
                    <p>{testimonial.quote}</p>
                    <h6>{testimonial.author}</h6>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="swiper-dot text-center pt-5">
            <div className="dot"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KidsaTestimonial;
